import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/spinningWheelApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonTemplate from "../../../../components/Apps/SpinningWheel/Template/CommonTemplate";

//Import Tabs
import ContentTab from "../../../../components/Apps/SpinningWheel/ContentTab";
import SettingsTab from "../../../../components/Apps/SpinningWheel/SettingsTab";
import NotificationsTab from "../../../../components/Apps/SpinningWheel/NotificationsTab";
import ThemeTab from "../../../../components/Apps/SpinningWheel/ThemeTab";

export default function EditSpinningWheel() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("");
    const [selectedLayout, setSelectedLayout] = useState("");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Spinning Wheel");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setTemplateId] = useState(null); 
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);

    const [spinningWheelTabData, setSpinningWheelTabData] = useState({
        is_website_frontend: "",  
        heading: "",
        description: "",
        is_show_email: 1,
        logo: 1,
        footer_text: "",
        show_popup_type: "Instantly",
        is_show_reopen_button: 1,
        button_text: "",
        button_icon: "",
        button_position: "right-side",
        pages_types: "All_Pages",
        devices_types: "All_Pages",
        language_types: "English",
        is_prize_confirmation_to_client: 1,
        is_owner_notification: 1,
        owner_email: "",
        background_color: "",
        text_color: "",
        accent_color: "", 
        email_field_error_color: "",
        font_type: "Default",
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateSpinningWheelTabData = (key, value) => {
        setSpinningWheelTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    }; 

    const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Settings", icon: "settings.png", label: "Settings" },
      { key: "Notifications", icon: "notifications.png", label: "Notifications" },
      { key: "Theme", icon: "theme.png", label: "Theme" },
  ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setTemplateId(uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setSpinningWheelTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid,setSpinningWheelTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(spinningWheelTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/spinning-wheel');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/spinning-wheel/icons//${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Content" && (
                        <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId} updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} setRefreshWidgetList={setRefreshWidgetList} />
                    )}
                    {activeSection === "Settings" && (
                        <SettingsTab updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} />
                    )}
                    {activeSection === "Notifications" && (
                        <NotificationsTab updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} />
                    )}
                    {activeSection === "Theme" && (
                        <ThemeTab updateSpinningWheelTabData={updateSpinningWheelTabData} spinningWheelTabData={spinningWheelTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/spinning-wheel"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/spinning-wheel/spinning-wheel.svg`} alt="spinning-wheel"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/spinning-wheel/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/spinning-wheel" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Spinning Wheel <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common template*/}
                    <CommonTemplate isTemplateId={isTemplateId} spinningWheelTabData={spinningWheelTabData} refreshWidgetList={refreshWidgetList} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 